import TrackingTypes from '@app/tracking/events';
import TrackingReactor from '@app/tracking/reactor';
import GoogleAnalyticsUniversal from '@app/tracking/adapters/GoogleAnalyticsUniversal';
import GoogleAnalyticsGTag from '@app/tracking/adapters/GoogleAnalyticsGTag';
import FacebookPixel from '@app/tracking/adapters/FacebookPixel';
import PinterestTag from '@app/tracking/adapters/PinterestTag';
import LinkedInInsight from '@app/tracking/adapters/LinkedInInsight';
import WebVitalsStatistics from '@app/tracking/adapters/WebVitalsStatistics';
export const EventType = TrackingTypes;
export const EventTracking = TrackingReactor;
export default {
    /**
     * All providers start listening for tracking events
     */
    start() {
        const googleTrackingConfig = window.GOOGLE_ANALYTICS_TRACKING || null;
        const facebookTrackingConfig = window.FACEBOOK_PIXEL_TRACKING || null;
        const pinterestTrackingConfig = window.PINTEREST_TAG_TRACKING || null;
        const linkedinTrackingConfig = window.LINKEDIN_INSIGHT_TRACKING || null;
        /**
         * Initalize Google Analytics Universal tracking
         */
        if (googleTrackingConfig && googleTrackingConfig.implementation === 'ua') {
            new GoogleAnalyticsUniversal(googleTrackingConfig.scriptPath, googleTrackingConfig.propertyId, googleTrackingConfig.anonymizeIp);
        }
        /**
         * Initalize Google Tag Manager tracking
         */
        if (googleTrackingConfig && googleTrackingConfig.implementation === 'gtag') {
            new GoogleAnalyticsGTag(googleTrackingConfig.scriptPath, googleTrackingConfig.propertyId, googleTrackingConfig.anonymizeIp);
        }
        /**
         * Initalize Facebook Tracking Pixel
         */
        if (facebookTrackingConfig) {
            new FacebookPixel(facebookTrackingConfig.pixelId, facebookTrackingConfig.scriptPath);
        }
        /**
         * Initalize Pinterest Tracking Tag
         */
        if (pinterestTrackingConfig) {
            new PinterestTag(pinterestTrackingConfig.tagId, pinterestTrackingConfig.scriptPath);
        }
        /**
         * Initalize LinkedIn Insight Tracking
         */
        if (linkedinTrackingConfig) {
            new LinkedInInsight(linkedinTrackingConfig.partnerId, linkedinTrackingConfig.leadConversionId, linkedinTrackingConfig.scriptPath);
        }
        if (window.MEASURE_WEB_VITALS) {
            new WebVitalsStatistics();
        }
    },
    /**
     * Stops all event tracking providers from listening to events
     */
    stop() {
        TrackingReactor.destroy();
    }
};
